import { useState, useRef } from "react";
import { fetchSubscriptionStatus, createSubscriptionInvoice } from "../services/api/subscription";

export function useSubscriptionPayment(userId: number | null, onSuccess: () => void) {
  const [paying, setPaying] = useState(false);
  const [payError, setPayError] = useState<string | null>(null);
  const pollingRef = useRef<null | ReturnType<typeof setInterval>>(null);

  const handlePay = async () => {
    if (!userId) {
      setPayError("Ошибка: Не определён userID");
      return;
    }
    setPayError(null);
    setPaying(true);
    try {
      const { invoice_link } = await createSubscriptionInvoice(userId);

      if (window.Telegram?.WebApp?.openInvoice) {
        window.Telegram.WebApp.openInvoice(invoice_link, () => startPolling());
      } else {
        window.open(invoice_link, "_blank");
        startPolling();
      }
    } catch {
      setPayError("Ошибка при генерации платежа");
      setPaying(false);
    }
  };

  const startPolling = () => {
    let attempts = 0;
    if (pollingRef.current) clearInterval(pollingRef.current);

    pollingRef.current = setInterval(async () => {
      attempts++;
      const sub = await fetchSubscriptionStatus();
      if (sub.isActive) {
        setPaying(false);
        if (pollingRef.current) clearInterval(pollingRef.current);
        pollingRef.current = null;
        onSuccess();
      }
      if (attempts >= 15) {
        setPaying(false);
        setPayError("Платёж не подтверждён. Попробуйте ещё раз.");
        if (pollingRef.current) clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    }, 2000);
  };

  return {
    paying,
    payError,
    handlePay,
  };
}
